import {connect} from "react-redux";

const Button_More = (props) => {
    return(
        <div className={`button_more_div button_more_div_${props.color_background}`}>
            <i className="fa-solid fa-ellipsis button_more"></i>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Button_More);